var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoxNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2385 7.59253C12.2385 7.59253 12.5302 7.8842 12.8219 8.46753C12.8219 8.46753 13.7483 7.0092 14.5719 6.71753",
    stroke: "#2E77D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33041 4.67915C7.87297 4.61745 6.74699 4.78534 6.74699 4.78534C6.03599 4.83618 4.67343 5.23478 4.67344 7.56269C4.67346 9.8708 4.65837 12.7163 4.67344 13.8506C4.67344 14.5437 5.10256 16.1603 6.58782 16.2469C8.39314 16.3523 11.645 16.3747 13.137 16.2469C13.5364 16.2244 14.8661 15.9109 15.0344 14.4641C15.2088 12.9654 15.1741 11.9238 15.1741 11.6759",
    stroke: "#2E77D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 7.59245C16.3333 9.20328 15.0262 10.5091 13.4139 10.5091C11.8015 10.5091 10.4944 9.20328 10.4944 7.59245C10.4944 5.98162 11.8015 4.67578 13.4139 4.67578C15.0262 4.67578 16.3333 5.98162 16.3333 7.59245Z",
    stroke: "#2E77D0",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57202 11.0925H9.90534",
    stroke: "#2E77D0",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57202 13.4258H12.2387",
    stroke: "#2E77D0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoxNew);
export default __webpack_public_path__ + "static/media/dox-new.3d606c4ae47a8389708c4ae04eb8c77a.svg";
export { ForwardRef as ReactComponent };